import SessionCache from '@plugins/cache/index';

const restrictedIds = ['GDPR_BLOQ'];

const cache = new SessionCache('communications');

export const useCommunicationsStore = defineStore('m-communications', {
	state: () => ({
		isBlocked: false,
		isRestricted: false,
		isCommunicationShown: false,
		currentCampaign: {},
		isAcceptancesShown: false,
	}),

	actions: {
		/**
		 * @param {Object} Store
		 * @param {String} type
		 * @returns []
		 */
		async getAnnouncements({ type, refresh }) {
			const MAX_SLIDES = 3;
			const isPrelogin = type === 'prelogin';
			const isPostlogin = type === 'postlogin';
			const prefix = isPrelogin ? type : 'communications';
			const url = `/${prefix}/communications`;
			const method = 'GET';

			if (isPostlogin && this.isCommunicationShown) {
				return Promise.resolve({ data: [] });
			}

			const spaceIds = {
				postlogin: 2,
				banner: 3,
			};

			const queryParams = isPrelogin
				? {
						language: useSessionStore().lang,
						company: useAppStore().companyId,
					}
				: { spaceId: spaceIds[type] };

			const cacheKey = `communications/${type}`;

			if (refresh) {
				SessionCache.clear(cacheKey);
			}

			if (cache.has(cacheKey)) {
				return Promise.resolve(cache.get(cacheKey));
			}

			/* istanbul ignore next */
			if (isPrelogin) {
				await useSecureStore().createSession();
			}

			return useServiceStore()
				.request({
					service: {
						request: {
							url,
							method,
						},
					},
					queryParams,
				})
				.then(({ data: { data } }) => {
					const sortedData = data
						.sort((a, b) => a.type?.priority - b.type?.priority)
						.slice(0, MAX_SLIDES);
					const isBlocked = sortedData.some((item) => item.blocking);
					const isRestricted = sortedData.some((item) => restrictedIds.includes(item.id));

					this.isBlocked = isBlocked;
					this.isRestricted = isRestricted && !isBlocked;

					if (type !== 'postlogin') {
						cache.set(cacheKey, sortedData);
					}

					return sortedData;
				})
				.catch(() => {});
		},

		changeAnnouncementData({ id, data }) {
			const url = `/communications/communications/${id}`;
			const method = 'PATCH';

			return useServiceStore().request({
				service: {
					request: {
						url,
						method,
					},
				},
				payload: { ...data },
			});
		},

		setAnnauncementCtaPressed({ id, ctaPressed }) {
			return this.changeAnnouncementData({
				id,
				data: { ctaPressed },
			});
		},

		setAnnouncementFeedback({ id, feedback }) {
			return this.changeAnnouncementData({
				id,
				data: { feedback },
			});
		},

		setAnnouncementImpression(id) {
			return this.changeAnnouncementData({
				id,
				data: { impressions: 1 },
			});
		},

		postLoginDisplayed(value) {
			this.isCommunicationShown = value;
		},

		setCurrentCampaign(value) {
			this.currentCampaign = value;
		},

		acceptanceCampaignDisplayed(value) {
			this.isAcceptancesShown = value;
		},
	},
});
